import { SymbolInfoColumns } from 'symbols/symbolInfo/columns';

export const DefaultFallback = 'DEFAULT';
export const IndexMappingsUserPreferenceKey = 'IndexMappingsS';

export interface IndexMapping {
    index: string;
    attribute: SymbolInfoColumns;
    value: string;
}

export type IndexMappingsState = {
    [symbology: string]: IndexMapping[];
};

export const initialIndexMappingsState: IndexMappingsState = {};
